import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
	header: {
		textAlign: 'center',
		padding: '8px 10px',
		fontSize: '26px',
		lineHeight: '39px',
		fontWeight: 700,
		color: '#595959',
	},
	title: {
		textAlign: 'center',
		fontSize: '14px',
		marginTop: '20px',
	},
};

class ResponseDialogTempate extends React.Component {
	render() {
		const {
			addedCount,
			duplicates,
			duplicatesCount,
			invalid,
			invalidCount,
			totalCount,
			notAllowedByCountry,
			notAllowedByCountryCount,
			classes,
		} = this.props;

		const sortedDuplicates = duplicates.sort((a, b) => {
			return a.organizationName > b.organizationName
				? 1
				: a.organizationName < b.organizationName
					? -1
					: 0;
		})

		const hasInvalidNumbers = Boolean(invalidCount && invalidCount > 0);
		const hasDuplicateNumbers = Boolean(duplicatesCount && duplicatesCount > 0);
		const hasNotAllowedByCountryNumbers = Boolean(notAllowedByCountryCount && notAllowedByCountryCount > 0);

		const oneInvalid = invalidCount === 1;
		const oneNotAllowedByCountry = notAllowedByCountryCount === 1;

		return (
			<div>
				<div className={classes.header}>
					Upload completed!
				</div>
				<div className={classes.title}>
					{addedCount} unique phone numbers out of {totalCount} numbers uploaded successfully!
				</div>
				{
					hasNotAllowedByCountryNumbers && (
						oneNotAllowedByCountry
							? <div className={classes.title}>Failed to upload the following Phone number: <b>{notAllowedByCountry[0]}</b> Please, make sure that this number belongs to the Countries from the 'Available Countries' list</div>
							: <div>
									<div className={classes.title}>
										Failed to upload the following Phone numbers. Please, make sure that these numbers belong to the Countries from the 'Available Countries' list:
									</div>
									<ul>
										{
											notAllowedByCountry.map((item, index) => (
												<li key={index}>
													<b>{item}</b>
												</li>
											))
										}
									</ul>
								</div>
					)
				}
				{
					hasInvalidNumbers && (
						oneInvalid
							? <div className={classes.title}>Failed to upload the following Phone number due to the format: <b>{invalid[0]}</b>.</div>
							: <div>
									<div className={classes.title}>
										Failed to upload the following {invalidCount} phone numbers, due to the format:
									</div>
									<ul>
										{
											invalid.map((item, index) => (
												<li key={index}>
													<b>{item}</b>
												</li>
											))
										}
									</ul>
								</div>
					)
				}
				{
					hasDuplicateNumbers &&
					<div>
						<div className={classes.title}>
							The following {duplicatesCount} phone numbers already present in the Organization:
						</div>
						<ul>
							{sortedDuplicates.map(({ phoneNumber, organizationName }, index) => (
								<li key={index}>
									<b>{phoneNumber}</b> – {organizationName}
								</li>
							))}
						</ul>
					</div>
				}
			</div>
		);
	}
}


export default withStyles(styles)(ResponseDialogTempate);
